import { render } from "./GetIncomePopup.vue?vue&type=template&id=24a3bd9e&scoped=true"
import script from "./GetIncomePopup.vue?vue&type=script&lang=js"
export * from "./GetIncomePopup.vue?vue&type=script&lang=js"

import "./GetIncomePopup.vue?vue&type=style&index=0&id=24a3bd9e&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24a3bd9e"]])

export default __exports__